import React, { useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth';

const Navbar = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const { isAuthenticated, logout } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  // Left navigation links
  const leftLinks = [
    { path: '/about', label: 'About' },
    { path: '/system-flow', label: 'System' },
    { path: '/our-approach', label: 'Approach' },
  ];

  // Right navigation links
  const rightLinks = [
    { path: '/insurance', label: 'Insurance' },
    { path: '/who-we-serve', label: 'Who We Serve' },
    { path: '/contact', label: 'Contact' },
  ];

  const handleLogout = async () => {
    await logout();
    window.location.href = '/'; // Hard redirect to Home page
  };

  return (
    <nav className="navbar-minimal">
      <div className="navbar-minimal-container">
        {/* Left Links */}
        <div className="navbar-left">
          {leftLinks.map((link) => (
            <Link
              key={link.path}
              to={link.path}
              className={`navbar-minimal-link ${location.pathname === link.path ? 'active' : ''}`}
            >
              {link.label.toUpperCase()}
            </Link>
          ))}
        </div>

        {/* Center Logo */}
        <Link to="/" className="navbar-minimal-logo">
          <img src={`${process.env.PUBLIC_URL}/Yathartha-Logo.png`} alt="Yathartha" className="navbar-logo-img" />
        </Link>

        {/* Right Links */}
        <div className="navbar-right">
          {rightLinks.map((link) => (
            <Link
              key={link.path}
              to={link.path}
              className={`navbar-minimal-link ${link.isButton ? 'is-button' : ''} ${location.pathname === link.path ? 'active' : ''}`}
            >
              {link.label.toUpperCase()}
            </Link>
          ))}
          {isAuthenticated && (
            <button
              onClick={handleLogout}
              className="navbar-minimal-link logout-btn-minimal"
            >
              LOGOUT
            </button>
          )}
        </div>

        {/* Mobile Menu Toggle */}
        <button
          className="navbar-minimal-toggle"
          onClick={toggleMobileMenu}
          aria-label="Toggle menu"
        >
          <span></span>
          <span></span>
          <span></span>
        </button>

        {/* Mobile Menu */}
        {isMobileMenuOpen && (
          <div className="navbar-minimal-mobile">
            <div className="navbar-minimal-mobile-content">
              {[...leftLinks, ...rightLinks].map((link) => (
                <Link
                  key={link.path}
                  to={link.path}
                  className={`navbar-minimal-mobile-link ${link.isButton ? 'is-button' : ''}`}
                  onClick={() => setIsMobileMenuOpen(false)}
                >
                  {link.label.toUpperCase()}
                </Link>
              ))}
              {isAuthenticated && (
                <button
                  onClick={() => {
                    setIsMobileMenuOpen(false);
                    handleLogout();
                  }}
                  className="navbar-minimal-mobile-link"
                  style={{ background: 'transparent', border: 'none', textAlign: 'left', cursor: 'pointer', fontFamily: 'inherit' }}
                >
                  LOGOUT
                </button>
              )}
            </div>
          </div>
        )}
      </div>
    </nav>
  );
};

export default Navbar;
